export default "__VITE_ASSET__DVcrhSqt__"